import { Pipe, PipeTransform } from '@angular/core';

export type ByteUnit = 'B' | 'kB' | 'KB' | 'MB' | 'GB' | 'TB';

@Pipe({
  name: 'bytes'
})
export class BytesPipe implements PipeTransform {
  transform(input: any, decimals = 2): any {
    if (input === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(input) / Math.log(k));

    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return parseFloat((input / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
